import { render, staticRenderFns } from "./LoginDisabledError.vue?vue&type=template&id=22d41f84&scoped=true&lang=pug&"
import script from "./LoginDisabledError.vue?vue&type=script&lang=ts&"
export * from "./LoginDisabledError.vue?vue&type=script&lang=ts&"
import style0 from "./LoginDisabledError.vue?vue&type=style&index=0&id=22d41f84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d41f84",
  null
  
)

export default component.exports